import { mapActions,mapGetters } from "vuex"

export const DepartChoosetMixin = {
    data(){
      return {
        areaLoading: false,
        collapsed: false,// 区域是否收缩
        currSelected: {},
        selectedKeys: [],
        departTreeData: [],
        checkStrictly: true,
        iExpandedKeys: [],
        autoExpandParent: true,
        canceldata:[],
        areaArrList: [],
        searchAreaValue: '',
        rootOpened: true,
        // 20220228改为elementui中tree新增的属性
        defaultProps: {
          children: 'children',
          label: 'title'
        },
        currentNodeKey: null
      }
    },
    watch: {
      searchAreaValue(val) {
        this.$refs.departTree.filter(val);
      }
    },
    methods: {
        /**
         * 重新设置标题自定义
         * @param {*} arr 
         */
        reWriterWithSlot(arr){
          for(let item of arr){
            if(item.children && item.children.length>0){
              this.reWriterWithSlot(item.children)
              let temp = Object.assign({},item)
              temp.children = {}
              item.scopedSlots={ title: 'title' }
              this.areaArrList.push(temp)
            }else{
              this.areaArrList.push(item)
              item.scopedSlots={ title: 'title' }
            }
          }
        },
        setThisExpandedKeys(arr){
          if(arr && arr.length>0){
            let keys = []
            for(let item of arr){
              if(item.children && item.children.length>0){
                keys.push(item.id)
              }
            }
            this.iExpandedKeys=[...keys]
          }else{
            this.iExpandedKeys=[]
          }
        },
        refresh() {
          this.loading = true;
          this.loadTree();
        },
        onExpand(expandedKeys) {
          console.log('onExpand', expandedKeys)
          this.iExpandedKeys = expandedKeys;
          this.autoExpandParent = false;
        },
        /*
        onSearch(value) {
            let that = this
            if (value) {
              searchAreaByKeywords({keyWord: value}).then((res) => {
                if (res.success) {
                  that.departTree = []
                  if(!isNull(res.result)) {
                    for (let i = 0; i < res.result.length; i++) {
                        let temp = res.result[i];
                        that.departTree.push(temp);
                      }
                  }
                } else {
                  that.$message.warning(res.message)
                }
              })
            } else {
              that.loadTree();
            }
        },
        */
        onSearch(value){
          console.log("执行onSearch")
          const expandedKeys = this.areaArrList.map((item) => {
            if (item.title.indexOf(value) > -1) {
              return this.getParentKey(item.key,this.departTree)
            }
            return null
          }).filter((item, i, self) => item && self.indexOf(item) === i)
  
          console.log(expandedKeys)
          Object.assign(this, {
            iExpandedKeys: expandedKeys,
            searchAreaValue: value,
            autoExpandParent: true,
          })
        },
        getParentKey(currKey,treeData){
          let parentKey
          for (let i = 0; i < treeData.length; i++) {
            const node = treeData[i]
            if (node.children) {
              if (node.children.some(item => item.key === currKey)) {
                parentKey = node.key
              } else if (this.getParentKey(currKey, node.children)) {
                parentKey = this.getParentKey(currKey, node.children)
              }
            }
          }
          return parentKey
        },
        onSelect(selectedKeys, e) {
            this.selectedKeys = selectedKeys;
            this.hiding = false;
            let record = e.node.dataRef;
            // 选中和取消选中都会执行此方法，所以需要根据selected进行判做响应操作
            if(e.selected) {
              this.currSelected = Object.assign({}, record);
            }else{
              this.currSelected = {};
            }
            
            
            this.loadData(1);
        },
        getCurrSelectedTitle() {
            return !this.currSelected.title ? '' : this.currSelected.title
        },
        resetAareaData() {
          console.log("areaChoose");
          this.hiding = true;
          this.checkedKeys = [];
          this.currSelected = {};
          this.selectedKeys = [];
          if(this.rootOpened){
            this.setThisExpandedKeys(this.departTree)
          }

          // 20220228修改的
          this.currentNodeKey = null;
          if(this.$refs.departTree) {
            this.$refs.departTree.setCheckedKeys([])
          }
          
        },
        unselect() {
          this.resetAareaData();
          this.loadData(1);
        },

        // 以下是20220228组件改为elementui中tree组件后做的相应的配置
        nodeClick(record,node,data) {
          //this.$refs.departTree.setCurrentKey(null)
          //this.$refs.departTree.setCheckedKeys([])
          console.log(record)
          console.log(node)
          console.log(data)
          // 选中和取消选中都会执行此方法，所以需要根据selected进行判做响应操作
          if(node.checked) {
            this.currentNodeKey = record.id
            this.$refs.departTree.setCheckedKeys([record.id])
            //this.$refs.departTree.setCurrentKey(record.id)
            this.currSelected = Object.assign({}, record);
          }else{
            this.currentNodeKey = null
            this.currSelected = {};
          }
          this.loadData(1);
        },
        nodeCheck(record,node) {
            console.log(node);
            this.departList = [];
            this.checkedKeys = node.checkedKeys;
            let checkedNodes = node.checkedNodes
            for (let i = 0; i < checkedNodes.length; i++) {
            let de = checkedNodes[i];
            let depart = {key:"",value:"",title:""};
            depart.key = de.key;
            depart.value = de.key;
            depart.title = de.title;
            this.departList.push(depart);
            }
        },
        filterNode(value, data) {
          console.log(data)
          if (!value) return true;
          return data.title.indexOf(value) !== -1;
        },
    }
}